export default __webpack_public_path__ + "static/media/Authentication.82112984.svg";